import React from "react";
import "../../style/common/footerBar.scss";
import { useNavigate } from "react-router-dom";
import PagePath from "../../util/RoutePagePath";
import { routeToPage } from "../../util/RouteToPage";
import Instagram from "../../icon/Instagram";
import Facebook from "../../icon/Facebook";
import Twiter from "../../icon/Twiter";
import { policyGroups } from "../../data/policies";

const FooterBar = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#ebe9d9] text-black">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid gap-12 lg:grid-cols-[1fr_3fr]">
          <div className="lg:pr-10">
            <p className="mb-6 text-[13px] uppercase tracking-[0.25em]">
              Newsletter
            </p>
            <div className="flex items-center border-b border-black pb-3">
              <input
                type="email"
                aria-label="Email address"
                placeholder="Enter your email"
                className="w-full bg-transparent text-[13px] outline-none placeholder:text-black/40"
              />
              <button
                type="button"
                className="text-[11px] uppercase tracking-[0.2em] transition-opacity hover:opacity-50"
              >
                Submit
              </button>
            </div>
            <div className="mt-6 flex items-center gap-5">
              <button
                type="button"
                aria-label="Instagram"
                className="transition-opacity hover:opacity-40"
              >
                <Instagram size={15} />
              </button>
              <button
                type="button"
                aria-label="Facebook"
                className="transition-opacity hover:opacity-40"
              >
                <Facebook size={15} />
              </button>
              <button
                type="button"
                aria-label="Twitter"
                className="transition-opacity hover:opacity-40"
              >
                <Twiter size={15} />
              </button>
            </div>
          </div>

          <nav
            aria-label="Policies"
            className="grid gap-9 sm:grid-cols-2 xl:grid-cols-4"
          >
            {policyGroups.map((group) => (
              <div key={group.title}>
                <p className="mb-5 text-[12px] uppercase tracking-[0.2em]">
                  {group.title}
                </p>
                <ul className="space-y-2.5 text-[12px] leading-5 text-black/70">
                  {group.policies.map(([slug, title]) => (
                    <li key={slug}>
                      <button
                        type="button"
                        className="text-left transition-colors hover:text-black"
                        onClick={() =>
                          routeToPage(navigate, `/policies/${slug}`)
                        }
                      >
                        {title}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-black/10 pt-6 text-[11px] text-black/50 md:flex-row md:items-center md:justify-between">
          <p>© 2026 Corvantis. All rights reserved.</p>
          <div className="flex gap-5">
            <button
              type="button"
              onClick={() => routeToPage(navigate, PagePath.ABOUT_PAGE)}
            >
              About Us
            </button>
            <button
              type="button"
              onClick={() => routeToPage(navigate, PagePath.CONTACT_PAGE)}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterBar;
